import { MainLogo } from 'styles'

export const HomeButton = () => {
  return (
    <a href="https://cardashift.com" target="_blank" rel="noreferrer">
      <MainLogo src="/logo.png" alt="logo" />
    </a>
  )
}
